import React from 'react';
import { Route, Link } from 'react-router-dom';
import { Animated } from "react-animated-css";
import { slide as Menu } from 'react-burger-menu'

import menus from './menu';
import { latestNewsletter } from '../../../config';
import logo from '../../../assets/front/img/header/logo_karaedu_175x44.png';
import '../../../assets/front/css/custom/burger.css';

class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            q: '',
            active: -1,
            clicked: -1,
            isFormOpen: false,
            isMenuOpen: false,
            headerClasses: 'g-bg-white g-py-10',
            headerMargin: 0
        };
        this.topbarRef = React.createRef();

        latestNewsletter(0).then((res) => {
            this.latestNewsletterId = res;
        });
    }

    componentDidMount() {
        this.topbarHeight = this.topbarRef.current.offsetHeight;
        window.addEventListener('scroll', this.listenToScroll)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.listenToScroll)
    }

    listenToScroll = event => {
        // header class change
        // u-header__section u-header__section--light g-bg-white u-shadow-v18 g-py-0 js-header-change-moment

        let offset = window.pageYOffset;
        if (offset === 0 && this.state.headerClasses !== 'g-bg-white g-py-10') {
            this.setState({ headerClasses: 'g-bg-white g-py-10' });
        } else if (offset > 0 && offset < 100 && this.state.headerClasses !== 'g-bg-white-opacity-0_8 g-py-10') {
            this.setState({ headerClasses: 'g-bg-white-opacity-0_8 g-py-10' });
        } else if (offset > 100 && this.state.headerClasses !== 'g-bg-white u-shadow-v18 g-py-0') {
            this.setState({ headerClasses: 'g-bg-white u-shadow-v18 g-py-0 js-header-change-moment' });
        }

        // minus margin
        let top = -((offset - this.topbarHeight) + this.topbarHeight);
        if (top > -(this.topbarHeight)) {
            this.setState({ headerMargin: top });
        }
        // missing case
        if (top < -(this.topbarHeight) && this.state.headerMargin !== -(this.topbarHeight)) {
            this.setState({ headerMargin: -(this.topbarHeight) });
        }

    }

    onMouseEnter(i) {
    }

    onMouseLeave(i) {
        this.setState({ active: i });
    }

    onMouseOver(i) {
        this.setState({ active: i });
    }

    onMouseOut(i) {
    }

    onClick(event) {
        this.setState({ isFormOpen: !this.state.isFormOpen });
    }

    onChange(event) {
        const { name, value } = event.target;
        // 보안 관련 추후 보완
        const v = value.toLowerCase();
        if (v.indexOf("javascript") > -1) return;
        this.setState({ [name]: value });
    }

    // hamburger menu 
    handleStateChange(state) {
        this.setState({ isMenuOpen: state.isOpen })
    }
    
    closeMenu() {
        this.setState({ isMenuOpen: false })
    }

    render() {

        // https://github.com/oblador/react-native-animatable
        // https://stackoverflow.com/questions/53659477/react-stop-start-fade-out-on-mouseenter-and-mouseleave-without-jquery

        return (
            <header style={{ marginTop: this.state.headerMargin }} id="js-header" data-header-fix-moment="100"
                className="u-header u-header--sticky-top u-header--toggle-section u-header--change-appearance" >

                {/* 톱바 */}
                <div ref={this.topbarRef} className="u-header__section u-header__section--hidden u-header__section--dark g-bg-white g-transition-0_3 g-py-12">
                    <div className="container">
                        <div className="row flex-column flex-md-row justify-content-between align-items-center g-color-black g-font-weight-600">
                            <div className="col-auto g-px-15">
                                <ul className="list-inline g-overflow-hidden mb-0">
                                    <li className="list-inline-item g-mx-4 g-mt-10"><a className="g-color-black" href="https://ekara.org" target="_balank">동물권행동 카라</a></li>
                                </ul>
                            </div>
                            <div className="col-auto g-pos-rel g-px-15">
                                <ul className="list-inline g-overflow-hidden mb-0">
                                    <li className="list-inline-item g-mx-4 g-mt-10"><a className="g-color-black" href="https://archive.ekara.org" target="_balank">카라아카이브</a></li>
                                    <li className="list-inline-item g-mx-4 g-mt-10">|</li>
                                    <li className="list-inline-item g-mx-4 g-mt-10"><a className="g-color-black" href="https://kara.dkyobobook.co.kr/main.ink" target="_balank">킁킁 전자도서관</a></li>
                                    <li className="list-inline-item g-mx-4 g-mt-10">|</li>
                                    <li className="list-inline-item g-mx-4 g-mt-10"><a className="g-color-black" href="https://www.saff.kr" target="_balank">서울동물영화제</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div onMouseEnter={() => this.onMouseEnter()} onMouseLeave={() => this.onMouseLeave()} 
                    className={`u-header__section u-header__section--light ${this.state.headerClasses}`}
                    data-header-fix-moment-exclude="g-bg-white-opacity-0_8 g-py-10"
                    data-header-fix-moment-classes="g-bg-white u-shadow-v18 g-py-0">

                    <nav className="js-mega-menu navbar navbar-expand-lg">

                        {/* 햄버거*/}
                        <div className="g-hidden-lg-up">
                            <Menu customBurgerIcon={<i className="fa fa-navicon g-font-size-26"></i>} isOpen={this.state.isMenuOpen} onStateChange={(state) => this.handleStateChange(state)}>
                                {menus.map((menu, i) => (
                                    <Route path={menu.path} exact={menu.exact} key={i} children={({ match }) => (
                                        <div><p className="mb-0"><Link to={menu.path} style={{ color: "#b8b7ad" }} onClick={() => this.closeMenu()} >{menu.title}</Link></p>
                                            {menu.children &&
                                                <ul className="list-unstyled g-pl-10 g-pb-0">
                                                    {menu.children && menu.children.map((submenu, i) => (
                                                        <li key={i}>
                                                            {submenu.path === "/activity/rental" && <a href="https://forms.gle/kiv52SysZ5MYfpre9" target="_blink" className="g-color-white">{submenu.title}</a>}
                                                            {submenu.path !== "/activity/rental" && <Link to={submenu.path} className="g-color-white" onClick={() => this.closeMenu()}>{submenu.title}</Link>}
                                                        </li>
                                                    ))}
                                                </ul>
                                            }
                                        </div>
                                    )} />
                                ))}
                            </Menu>

                        </div>

                         <div className="container">
                            {/* 로고 */}
                            <div>
                                <div className="g-hidden-sm-down">
                                    <Link to="/" className="navbar-brand g-ml-20--md g-ml-20--sm g-ml-0--lg"><img src={logo} className="w-100" alt="카라" /></Link>
                                </div>
                                <div className="g-hidden-md-up">
                                    <Link to="/" className="navbar-brand g-ml-20--md g-ml-20--sm g-ml-0--lg"><img src={logo} className="g-width-160" alt="카라" /></Link>
                                </div>
                            </div>  

                            {/* 모바일 검색 */}
                            <div className="g-hidden-lg-up">
                                <div className="g-pos-abs g-top-10 g-right-65">
                                    <a onClick={(e) => this.onClick(e)} className="g-color-main g-cursor-pointer"><i className="fa fa-search g-font-size-24"></i></a>
                                    <Animated animationIn="fadeInUp" animationOut="bounceUpDown fadeOutDown" isVisible={this.state.isFormOpen}>
                                        <form action="/home/search" method="GET"
                                            className={`u-searchform-v1 u-dropdown--css-animation g-bg-white g-pa-10 g-mt-20 g-mt-35--lg g-mt-15--lg--scrolling ${this.state.isFormOpen ? "" : "u-dropdown--hidden"}`}>
                                            <div className="input-group g-brd-primary--focus">
                                                <input name="q" className="form-control rounded-0 u-form-control" placeholder="검색어를 입력하세요" />
                                                <div className="input-group-addon p-0">
                                                    <button type="submit" className="btn rounded-0 u-btn-primary btn-md g-bg-primary--hover g-brd-primary--hover g-font-size-14 g-px-18">검색</button>
                                                </div>
                                            </div>
                                        </form>
                                    </Animated>
                                </div>
                            </div>
                            
                            {/* 메뉴 */}
                            <div className="collapse navbar-collapse align-items-center flex-sm-row g-pt-10 g-pt-5--lg g-mr-20--sm" id="navBar">
                                <ul className="navbar-nav text-uppercase g-font-weight-600 ml-auto">
                                    {menus.map((menu, i) => (
                                        <Route path={menu.path} exact={menu.exact} key={i} children={({ match }) => (
                                            <li data-animation-in="fadeIn" data-animation-out="fadeOut"
                                                onMouseOver={() => this.onMouseOver(i)}
                                                onMouseOut={() => this.onMouseOut(i)}
                                                className={'nav-item hs-has-sub-menu g-mx-10--lg g-mx-15--xl ' + (i === this.state.active ? 'hs-sub-menu-opened ' : '')} >

                                                <Link to={menu.path} className="nav-link g-py-0 g-px-20 g-font-header" aria-haspopup="true" aria-expanded="false" aria-controls="nav-submenu--features">{menu.title}</Link>

                                                {menu.children &&
                                                    <ul id="nav-submenu--features" className="hs-sub-menu list-unstyled u-shadow-v11 g-brd-top g-brd-primary g-brd-top-2 g-min-width-150 g-mt-30 g-mt-35--lg--scrolling">
                                                        {menu.children && menu.children.map((submenu, i) => (
                                                            <li className="dropdown-item" key={i}>

                                                                {/* 외부링크 => 사서냥이의 하루 , 교구대여 
                                                                {submenu.path === "/activity/rental" && <a href="https://forms.gle/kiv52SysZ5MYfpre9" target="_blink" className="nav-link g-py-2">{submenu.title}</a>}
                                                                {submenu.path === "/library/day" && <a href="https://www.instagram.com/kara_library/" target="_blink" className="nav-link g-py-2">{submenu.title}</a>} */}

                                                                {/* 숨김처리 => 킁킁리더 */}
                                                                {submenu.path === "/report/sniffleader" && <Link to={submenu.path} style={{ display: "none" }}>{submenu.title}</Link>}

                                                                {/* 뉴스레터 최신글 */}
                                                                {submenu.path === "/report/newsletter" && <Link to={{ pathname: `/details/report/newsletter/`+this.latestNewsletterId }} className="nav-link g-py-2">{submenu.title}</Link>} 

                                                                {submenu.path !== "/report/sniffleader" && submenu.path !== "/report/newsletter" && 
                                                                    <Link to={submenu.path} className="nav-link g-py-2">{submenu.title}</Link>}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                }
                                            </li>
                                        )} />
                                    ))}
                                </ul>
                            </div>
   
                            {/* 검색 */}
                            <div className="d-inline-block g-pos-rel g-valign-middle g-hidden-md-down">
                                <a onClick={(e) => this.onClick(e)} className="g-font-header g-color-main g-cursor-pointer" > <i className="fa fa-search g-font-size-24--sm"></i> </a>
                                <Animated animationIn="fadeInUp" animationOut="bounceUpDown fadeOutDown" isVisible={this.state.isFormOpen}>
                                    <form action="/home/search" method="GET"
                                        className={`u-searchform-v1 u-dropdown--css-animation g-bg-white g-pa-10 g-mt-20 g-mt-35--lg g-mt-15--lg--scrolling ${this.state.isFormOpen ? "" : "u-dropdown--hidden"}`}>
                                        <div className="input-group g-brd-primary--focus">
                                            <input onChange={e => this.onChange(e)} name="q" className="form-control rounded-0 u-form-control" placeholder="검색어를 입력하세요" />
                                            <div className="input-group-addon p-0">
                                                <button type="submit" className="btn rounded-0 u-btn-primary btn-md g-bg-primary--hover g-brd-primary--hover g-font-size-14 g-px-18">검색</button>
                                            </div>
                                        </div>
                                    </form>
                                </Animated>
                            </div>

                        </div>
                    </nav>
                </div>
            </header>

        )
    }
}

export default Header;








// WEBPACK FOOTER //
// ./src/components/front/header/header.js